import { IAccountModel } from './models/accountModel';
import useNetwork from './network';
import { IErrorModel } from './models/errorModel';

export const createAccount = async (lang: string, details: IAccountModel) => {
    const { createAccount } = useNetwork();
    const result = await createAccount(lang, details);

    if (result.status === 201) {
        return (await result.json()) as IAccountModel;
    } else {
        return (await result.json()) as IErrorModel;
    }
};

export const sendEmail = async (lang: string, email: string) => {
    const { sendEmail } = useNetwork();

    return await sendEmail(lang, email);
};

export const fetchAccount = async (lang: string, id: number) => {
    const { fetchAccount } = useNetwork();
    const result = await fetchAccount(lang, id);

    if (result.status === 200) {
        return (await result.json()) as IAccountModel;
    }
};

export const updateAccount = async (lang: string, id: string, details: IAccountModel) => {
    const { updateAccount } = useNetwork();
    const result = await updateAccount(lang, id, details);
    const json = await result.json();
    if (result.status === 200) {
        const updatedAccount = json as IAccountModel;
        if (updatedAccount) {
            window.location.reload();
        }
        return json as IAccountModel;
    } else {
        return json as IErrorModel;
    }
};

export const resetAccount = async (lang: string, id: string) => {
    const { resetAccount } = useNetwork();
    const result = await resetAccount(lang, id);
    const json = await result.json();
    if (result.status === 200) {
        return json as IAccountModel;
    } else {
        return json as IErrorModel;
    }
};
